import UploadBox from './UploadBox';
//import Vue from 'vue';
import { createApp } from 'vue'

import Router from 'vue-router';
import { uploadBoxRouter } from './router';
import { testIsNonEmptyString } from '../../../lib/test-and-assert/test-base';
import { getPiniaInstance } from '../../store/page-store';

function initVueUploadBox() {
    //Vue.use(Router);

    let uploaderMode = 'default';

    if (testIsNonEmptyString(global.pageConfig?.uploaderMode)) {
        uploaderMode = global.pageConfig.uploaderMode;
    }

    let uploaderBackground = 'bg-main-5';

    if (testIsNonEmptyString(global.pageConfig?.uploaderBackground)) {
        uploaderBackground = global.pageConfig.uploaderBackground;
    }

    let uploaderTextColor = '';

    if (testIsNonEmptyString(global.pageConfig?.uploaderTextColor)) {
        uploaderTextColor = global.pageConfig.uploaderTextColor;
    }

    createApp(UploadBox, {
        mode: uploaderMode,
        background: uploaderBackground,
        uploaderTextColor: uploaderTextColor,
    })
        .use(uploadBoxRouter)
        .use(getPiniaInstance())
        .mount('#vue-uploadbox');
}

export { initVueUploadBox };
